
import React from "react";
import { ScrollArea } from "@/components/ui/scroll-area";

interface DocumentTemplatesLayoutProps {
  children: React.ReactNode;
  header: React.ReactNode;
}

const DocumentTemplatesLayout = ({ children, header }: DocumentTemplatesLayoutProps) => {
  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100">
      {header}

      {/* Content com ScrollArea usando altura calculada */}
      <div className="flex-1 relative">
        <ScrollArea 
          className="absolute inset-0 w-full h-full"
          style={{ height: '100%' }}
        >
          <div className="p-6 min-h-full">
            {children}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};

export default DocumentTemplatesLayout;
